import { useEffect } from 'react'
import { OG_IMAGE_URL, SITE_URL, upsertLink, upsertMeta, upsertJsonLd, removeJsonLd, breadcrumbJsonLd, webApplicationJsonLd } from './useSeo'

const JSON_LD_ID = 'pv-rechner-jsonld'
const BREADCRUMB_ID = 'pv-rechner-breadcrumb'
const TITLE = 'Kostenloser PV-Rechner: Anlagengröße & Ersparnis berechnen | Roofora'
const DESCRIPTION =
  'Kostenlos & ohne Anmeldung: passende PV-Anlagengröße, Batteriespeicher-Empfehlung und ' +
  'jährliche Ersparnis in wenigen Minuten berechnen - unverbindlich, nichts wird gespeichert.'

/** SEO tags for the public, anonymous /pv-rechner tool - German-only and static like useBlogSeo,
 *  since the page itself carries no i18n-translated content (see PvRechnerPage). */
export function usePvRechnerSeo() {
  useEffect(() => {
    document.documentElement.lang = 'de'
    const canonicalUrl = `${SITE_URL}/pv-rechner`

    document.title = TITLE
    upsertMeta('name', 'description', DESCRIPTION)
    upsertMeta('property', 'og:title', TITLE)
    upsertMeta('property', 'og:description', DESCRIPTION)
    upsertMeta('property', 'og:url', canonicalUrl)
    upsertMeta('property', 'og:image', OG_IMAGE_URL)
    upsertMeta('name', 'twitter:title', TITLE)
    upsertMeta('name', 'twitter:description', DESCRIPTION)
    upsertMeta('name', 'twitter:image', OG_IMAGE_URL)
    upsertLink('canonical', canonicalUrl)

    upsertJsonLd(JSON_LD_ID, webApplicationJsonLd('Roofora PV-Rechner', DESCRIPTION, canonicalUrl))

    upsertJsonLd(
      BREADCRUMB_ID,
      breadcrumbJsonLd([
        { name: 'Roofora', url: `${SITE_URL}/de` },
        { name: 'PV-Rechner', url: canonicalUrl },
      ]),
    )

    return () => {
      removeJsonLd(JSON_LD_ID)
      removeJsonLd(BREADCRUMB_ID)
    }
  }, [])
}
